export enum ReactQueryKeys {
  GET_MODELS = 'GET_MODELS',
  GET_SHOPPING_CART = 'GET_SHOPPING_CART',
  GET_COMPANIES_INFINITE = 'GET_COMPANIES_INFINITE',
  GET_CATEGORIES_INFINITE = 'GET_CATEGORIES_INFINITE',
  GET_MODEL_CONFIGURATIONS = 'GET_MODEL_CONFIGURATIONS',
  GET_COMPANY = 'GET_COMPANY',
  GET_VERSIONS = 'GET_VERSIONS',
  GET_CUSTOM_VERSION = 'GET_CUSTOM_VERSION',
  GET_COMPANY_SHIPPING_ADDRESSES = 'GET_COMPANY_SHIPPING_ADDRESSES',
  GET_DELIVERY_DAYS = 'GET_DELIVERY_DAYS',
  GET_CUSTOM_MODELS = 'GET_CUSTOM_MODELS',
  // NEW QUERIES
  GET_SUPPLIER_ORDERS = 'GET_SUPPLIER_ORDERS',
  GET_SINGLE_ORDER = 'GET_SINGLE_ORDER',
  GET_SINGLE_QUOTATION = 'GET_SINGLE_QUOTATION',
  GET_QUOTATION_LINES = 'GET_QUOTATION_LINES',
  GET_QUOTATION_DELIVERY_DAYS = 'GET_QUOTATION_DELIVERY_DAYS',
  GET_COMPANY_BUYERS = 'GET_COMPANY_BUYERS',
  CHECK_IF_CART_EXISTS = 'CHECK_IF_CART_EXISTS',
  GET_ELIGIBLE_BUYERS = 'GET_ELIGIBLE_BUYERS',
  GET_SINGLE_BUYER = 'GET_SINGLE_BUYER',
  GET_BUYER_MODELS = 'GET_BUYER_MODELS',
  GET_BUYERS_ELIGIBLE_MODELS = 'GET_BUYERS_ELIGIBLE_MODELS',
  GET_MY_MODELS = 'GET_MY_MODELS',
  GET_COMPANIES_FOR_MODEL = 'GET_COMPANIES_FOR_MODEL',
  GET_MY_MODEL = 'GET_MY_MODEL',
  GET_COMPANIES_ELIGIBLE_FOR_MODEL = 'GET_COMPANIES_ELIGIBLE_FOR_MODEL',
  GET_USERS = 'GET_USERS',
  GET_BUYER_ORDERS = 'GET_BUYER_ORDERS',
  GET_BUYER_QUOTATIONS = 'GET_BUYER_QUOTATIONS',
  GET_COMPANY_SUPPLIERS = 'GET_COMPANY_SUPPLIERS',
  GET_COMPANIES_ELIGIBLE = 'GET_COMPANIES_ELIGIBLE',
  GET_CONFIGURATION_QUESTIONS = 'GET_CONFIGURATION_QUESTIONS',
  GET_TEMPLATES_INFINITE = 'GET_TEMPLATES_INFINITE',
  GET_SINGLE_TEMPLATE = 'GET_SINGLE_TEMPLATE',
}
